import { useState, type ReactNode } from "react";
import { type QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import {
    CATALOGUE_CACHE_MS,
    catalogueDehydrateOptions,
    cataloguePersister,
} from "./catalogueCache";

/** Restore after hydration, before queries start, so a reload reuses results without a request race. */
export default function CatalogueQueryProvider({
    client,
    children,
}: {
    client: QueryClient;
    children: ReactNode;
}) {
    const [persister] = useState(cataloguePersister);
    return (
        <PersistQueryClientProvider
            client={client}
            persistOptions={{
                persister,
                maxAge: CATALOGUE_CACHE_MS,
                buster: "catalogue-v1",
                dehydrateOptions: catalogueDehydrateOptions,
            }}
        >
            {children}
        </PersistQueryClientProvider>
    );
}
